(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .config(routes);

  /* ngInject */
  function routes($stateProvider) {
    $stateProvider
      .state('application.compliance_framework', {
        abstract: true,
        views: {
          '': {template: '<div ui-view></div>'},
          'top-nav': {
            templateUrl: '/templates/compliance_framework/layouts/top-nav.html',
            controller: 'TopNavController',
            controllerAs: 'topNavVm'
          },
          'side-nav': {
            templateUrl: '/templates/compliance_framework/layouts/side-nav.html',
            controller: 'SideNavController',
            controllerAs: 'sideNavVm'
          }
        }
      })
    ;
  }
})();
